import { ReactEditor } from 'slate-react';
import { Editor, Node, Range } from 'slate';
import { notEmpty } from 'utils/js';
import { AnyObject } from 'types';

type MaybeCustomNode = (Node & AnyObject) | null;

export type GetSelectedNode = (selection?: Range) => MaybeCustomNode;

/**
 * Get the currently selected custom annotation. This is used to position
 * the name editor and name display and to retrieve the name of the text snippet.
 * @param editor
 * @param selection
 */
export default function getSelectedNode(editor: ReactEditor): GetSelectedNode {
  return function (selection?: Range): MaybeCustomNode {
    try {
      const result = Array.from(
        Editor.nodes(editor, {
          mode: 'lowest',
          // @ts-ignore
          match: (node) => Boolean(node.isSelected),
        }),
      );

      if (notEmpty(result)) {
        return result[0][0];
      }

      // @ts-ignore
      const node = editor.findNode((node) => node?.isSelected);

      return node || null;
    } catch (error) {
      console.log(
        '---------------- getSelectedNode ERROR --------------------',
      );

      return null;
    }
  };
  /*      return function (selection?: Range): Node | null {
        try {
          const at = selection || editor.selection || undefined;

          const result = Array.from(
            Editor.nodes(editor, {
              at,
              match: (node) => Boolean(node.isSelected),
              mode: 'all',
            }),
          );

          if (notEmpty(result)) {
            const [[node]] = result;

            return node;
          }

          return null;
        } catch (error) {
          console.log(
            '---------------- getSelectedNode ERROR --------------------',
          );

          return null;
        }
      };*/
}
